import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { useGame } from "./store";

// FIRST-PERSON view: cart body is hidden. We still attach the parachute
// (overhead canopy) to the player position so it appears above the camera
// when deployed during AIRBORNE mode.

function Parachute({ open, area }) {
  const scale = open ? Math.sqrt(area) * 0.6 : 0.01;
  return (
    <group position={[0, 4.0, 0]} scale={[scale, scale * 0.7, scale]}>
      <mesh castShadow>
        <sphereGeometry args={[2.2, 18, 10, 0, Math.PI * 2, 0, Math.PI / 2]} />
        <meshStandardMaterial
          color="#ff4d6d"
          side={THREE.DoubleSide}
          roughness={0.55}
        />
      </mesh>
      {/* Ribs */}
      {Array.from({ length: 8 }).map((_, i) => (
        <mesh
          key={i}
          rotation={[0, (i / 8) * Math.PI * 2, 0]}
          position={[0, 0, 0]}
        >
          <torusGeometry args={[2.2, 0.04, 6, 16, Math.PI]} />
          <meshStandardMaterial color="#a8203a" />
        </mesh>
      ))}
      {/* Suspension cords */}
      {[
        [1.5, -1.6, 0],
        [-1.5, -1.6, 0],
        [0, -1.6, 1.5],
        [0, -1.6, -1.5],
      ].map((p, i) => (
        <mesh key={i} position={[p[0] / 2, p[1] / 2, p[2] / 2]}>
          <cylinderGeometry args={[0.02, 0.02, 2.6, 6]} />
          <meshStandardMaterial color="#ffffff" />
        </mesh>
      ))}
    </group>
  );
}

export default function Player() {
  const groupRef = useRef();
  const pos = useGame((s) => s.pos);
  const vel = useGame((s) => s.vel);
  const mode = useGame((s) => s.mode);
  const parachuteOpen = useGame((s) => s.parachuteOpen);
  const parachuteArea = useGame((s) => s.parachuteArea);

  useFrame(() => {
    if (!groupRef.current) return;
    groupRef.current.position.set(pos[0], pos[1], pos[2]);
    const v = new THREE.Vector3(vel[0], vel[1], vel[2]);
    if (v.length() > 0.01) {
      const dir = v.clone().normalize();
      const targetQuat = new THREE.Quaternion();
      const m = new THREE.Matrix4();
      m.lookAt(new THREE.Vector3(0, 0, 0), dir, new THREE.Vector3(0, 1, 0));
      targetQuat.setFromRotationMatrix(m);
      groupRef.current.quaternion.slerp(targetQuat, 0.2);
    }
  });

  return (
    <group ref={groupRef}>
      <Parachute
        open={mode === "AIRBORNE" && parachuteOpen}
        area={parachuteArea}
      />
    </group>
  );
}
